import {
  Suspense,
  type FC,
  type PropsWithChildren,
} from 'react';
import {
  Stack,
  IconButton,
  Typography,
} from '@mui/joy';
import {
  safeLazy,
  isDefined,
} from '@shared/lib';

const ArrowBackIcon = safeLazy(() => import('@mui/icons-material/ArrowBack'));

export type PurchaseTwoPaneLayoutContentProps = PropsWithChildren & {
  title?: string;
  onBack?(): void;
};

export const PurchaseTwoPaneLayoutContent: FC<PurchaseTwoPaneLayoutContentProps> = ({ title, children, onBack }) => (
  <Stack
    alignItems='center'
    justifyContent='center'
    sx={{
      paddingBlock: 2,
      paddingInline: 1.5,
    }}>
    {(isDefined(onBack) || isDefined(title)) && (
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
        sx={{
          width: '100%',
          marginBottom: 2,
          position: 'relative',
        }}>
        {isDefined(onBack) && (
          <IconButton
            onClick={onBack}
            sx={{ position: 'absolute', left: 0 }}>
            <Suspense>
              <ArrowBackIcon />
            </Suspense>
          </IconButton>
        )}
        {isDefined(title) && (
          <Typography
            sx={({ palette }) => ({
              color: palette.common.white,
              fontSize: 20,
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '30px',
            })}>
            {title}
          </Typography>
        )}
      </Stack>
    )}
    {children}
  </Stack>
);